// extracted by css-extract-rspack-plugin
export default {"milestoneLink":"MilestoneMetadata-module__milestoneLink__c0pCe_7","milestoneTitleTruncate":"MilestoneMetadata-module__milestoneTitleTruncate__wxUujVG"};